// components/features/agents/AgentRow.tsx
import React, { useState } from "react";
import { MoreVertical, Edit, Trash2, UserCheck, UserX, Phone, Mail } from "lucide-react";
import { Agent } from "../../../types/features/Agent";
import TableRow from "../../ui/TableRow";

interface AgentRowProps {
  agent: Agent;
  onAction: (agent: Agent) => void;
  onSelect?: (agent: Agent, isSelected: boolean) => void;
  isSelected?: boolean;
  selectable?: boolean;

}

export default function AgentRow({
  agent,
  onAction,
  onSelect,
  isSelected = false,
  selectable = false,

}: AgentRowProps) {
  const [showMenu, setShowMenu] = useState(false);

  const getStatusBadge = (status: string) => {
    if (status === "ACTIVE") {
      return (
        <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-medium bg-green-100 text-green-700">
          <UserCheck className="w-3 h-3" />
          Actif
        </span>
      );
    }
    return (
      <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-600">
        <UserX className="w-3 h-3" />
        Inactif
      </span>
    );
  };

  const formatDate = (date: string) => {
    return new Date(date).toLocaleDateString("fr-FR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };


  return (
    <TableRow
      item={agent}
      onAction={onAction}
      onSelect={onSelect}
      isSelected={isSelected}
      selectable={selectable}
      actionable={true}
    >
      <td className="py-3 px-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center text-green-700 font-semibold text-sm">
            {agent.full_name?.charAt(0) || "U"}
          </div>
          <div>
            <span className="font-medium text-gray-800 block">{agent.full_name}</span>
            <span className="text-xs text-gray-500">{agent.email}</span>
          </div>
        </div>
      </td>

      <td className="hidden sm:table-cell py-3 px-4">
        <div className="flex items-center gap-1 text-sm text-gray-600">
          <Phone className="w-3.5 h-3.5 text-gray-400" />
          {agent.phonenumber || "-"}
        </div>
      </td>

      <td className="hidden md:table-cell py-3 px-4">
        <span className="text-sm text-gray-600">{agent.departement || "-"}</span>
      </td>

      <td className="hidden lg:table-cell py-3 px-4">
        <span className="text-sm text-gray-500">{formatDate(agent.created_at)}</span>
      </td>

      <td className="py-3 px-4">{getStatusBadge(agent.status)}</td>

   
    </TableRow>
  );
}